import React from 'react';

import { Icon } from '@vp/swan';

import { sendFlyoutTriggerClickedEvent } from '../infrastructure/clients/client-side/trackingClient';

import { FlyoutTrigger } from './FlyoutTrigger';

interface FlyoutTriggerProps {
  iconType: Pick<React.ComponentPropsWithoutRef<typeof Icon>, 'iconType'>['iconType'];
  label: string;
  flyoutType: string;
  productKey: string;
}

export const PdpFlyoutTrigger: React.FC<FlyoutTriggerProps> = (props) => {
  return (
    <FlyoutTrigger
      iconType={props.iconType}
      label={props.label}
      onClick={() => sendFlyoutTriggerClickedEvent(props.flyoutType, props.productKey)}
    />
  );
};
